<div class="p-grid p-align-start vertical-container mt-1 container-fullsize">
    <!-- <div class="col-md-12 text-center" style="margin-bottom:-30px;">
        <img *ngIf="logo != null"  src="{{logo}}" class="logo" alt="Responsive image">
    </div> -->
    <div class="p-col-12  p-col-align-start  " id= "tableresultados">
        <div class="box text-center shadow-lg p-2 mb-2 bg-white rounded" style="min-height: 450px !important;">
            <div class=" mx-3 text-left">
                <span class=" mx-4 text-center font-weight-bolder text-success shadow">
                    <h2> Resultado Parcial Eleição {{resultadosEleicao?.titulo}}
                    <br>
                    <small>( {{resultadosEleicao?.dataInicio | date: 'dd/MM/yyyy HH:mm':'GMT'}} até {{resultadosEleicao?.dataFim | date: 'dd/MM/yyyy HH:mm':'GMT'}} )</small></h2>
                  </span >
                </div>
                <div class="mx-2 text-right">
                    <button class="btn btn-outline-secondary mx-3" (click)="exportVotantesParaExcel()" pTooltip="Baixar planilha de eleitores votantes">
                        <i class="fas fa-file-download"></i>
                    </button>
                    <button [disabled]="true" class="btn btn-outline-secondary" (click)="exportParaExcel()" pTooltip="Salvar planilha de resultados da eleição">
                        <i class="fas fa-save"></i>
                    </button>
                </div>
                <br>
              <!--   <form role="form" [formGroup]="formGroup" (ngSubmit)="onSubmit(formGroup.value)">
                    <div class="container d-inline-flex mb-5 mt-2">
                        <div class="row">
                            <div class="col-sm">
                                <p class="text-nowrap"><strong>Data Inicio</strong></p>
                            </div>
                            <div class="col-sm m-0">
                                <input class="form-control ext-input p-8"
                                type="date" min="2000-01-01" max="2100-12-31" placeholder="dd/MM/aaaa" formControlName="dataInicio" >
                            </div>
                            <div class="col-sm m-0">
                                <p class="text-nowrap"><strong>Data Fim</strong></p>
                            </div>
                            <div class="col-sm m-0">
                                <input class="form-control ext-input p-8"
                                type="date" min="2000-01-01" max="2100-12-31" placeholder="dd/MM/aaaa" formControlName="dataFim" >
                            </div>
                            <div class="col-sm m-0">
                                <button type="submit" class="btn btn-success btn-sm btn-primary btn-block">Filtrar</button>
                            </div>
                        </div>
                    </div>
                </form>
           <div class="table-responsive">
                <ul *ngFor="let p of listaPlanosFiltrada" class="px-3">
                    <h4 class="mb-4" *ngIf="p !=null  && p!= ''" >Votação <span *ngIf="p != null || p !='GERAL'"> {{p.toUpperCase()}}</span></h4>
                <table class="table table-fixed table-bordered"  *ngIf="p !=null  && p!= ''">           
                    <thead>
                        <tr>
                            <th scope="col" style="width:20%">Cargo</th>
                            <th scope="col" style="width:10%">Nº Vagas</th>
                            <th scope="col" style="width:20%">Candidato</th>
                            <th scope="col" style="width:20%">Quantidade de votos</th>
                            <th scope="col" style="width:20%" *ngIf="p !=null && p !='GERAL'  && p!= ''">Plano</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let res of resultados" [ngClass]="res.candidatoNome == 'Nulo' || res.candidatoNome == 'Branco' ? 'bntpo' : '' ">
                            <td *ngIf="isPlanoMatching(res.cargoPlano, p)">{{res.candidatoCargo}}</td>
                            <td *ngIf="isPlanoMatching(res.cargoPlano, p)">{{res.qtdElegiveis}}</td>
                            <td *ngIf="isPlanoMatching(res.cargoPlano, p)">{{res.candidatoNome}}</td>
                            <td *ngIf="isPlanoMatching(res.cargoPlano, p)">{{res.numVotos}}</td>
                            <td *ngIf="isPlanoMatching(res.cargoPlano, p)  && (res.cargoPlano !=null  && p !='GERAL' && p!= '')">{{p}}</td>
                        </tr>
                    </tbody>
                </table>
                <hr>
                <div class="mx-3 text-left" *ngIf="p !=null  && p!= ''">
                    <p>Total de votos: {{somaTotalPorPlano(p)}} </p>
                </div>
                </ul>
            </div>
            -->
        </div>
    </div>
</div>